
import React, { useEffect, useState } from 'react';
import { CheckboxInputComponent } from '../components/checkbox-input.component';

let isOnChangeTriggered = false;
export function CheckboxInputContainer ({ type, name, label, value, onValueChange, isDisabled, isRequired }: any) {
  // const [
  //   inputValue,
  //   setInputValue
  // ] = useState(value);
  // const debouncedInputValue = useDebounce(
  //   inputValue,
  //   FIVE_HUNDRED
  // );

  // useEffect(
  //   () => {
  //     if (debouncedInputValue && inputValue && debouncedInputValue === inputValue && isOnChangeTriggered) {
  //       isOnChangeTriggered = false;
     
  //       onValueChange({
  //         persist: () => {},
  //         target: {
  //           type: 'change',
  //           name,
  //           checked: debouncedInputValue,
  //         },
  //       });
  //     }
  //   },
  //   [debouncedInputValue]
  // )

  // useEffect(
  //   () => {
  //     setInputValue(value)
  //   },
  //   [value]
  // )

  return (

          <CheckboxInputComponent
              isDisabled={isDisabled}
              label={label}
              name={name}
              onValueChange={(event: any) => {
                isOnChangeTriggered = true;
                onValueChange(event.target.checked)
              }}
              type={type}
              value={value}
          />)
}
